import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { getHolidayList } from "_controllers/officer";
import authAxios from "setups/axios";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import { Toaster } from "react-hot-toast";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import GetAppIcon from "@mui/icons-material/GetApp";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";
import { DeleteConfirmationModel } from "utils/helperComponent";
import { toastMessage } from "utils/toastMessage";
import * as XLSX from "xlsx";
import { PageHeader, SectionCard, EmptyState, TablePager } from "_shared/ui";

// Centered, dark-safe modal surface. Square corners are inherited from the
// theme; only the paper background switches with light/dark mode.
const messageStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "92%", sm: "70%", md: "50%" },
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2.5, sm: 4 },
  textAlign: "left",
};

const Main = () => {
  const ref = useRef();
  let sampleFile = `https://jkmsfa.s3.ap-south-1.amazonaws.com/public/1709118067605-0.6807324395596748.xlsx`;

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletedItemId, setDeletedItemId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [bulkUploadData, setBulkUploadData] = useState([]);
  const [uploadModal, setUploadModal] = useState(false);

  const [Values, setValues] = useState({
    holidayDate: "",
    title: "",
    holidayType: "",
    region: [],
  });

  const [schemeErr, setschemeErr] = useState({
    title: false,
    holidayDate: false,
    holidayType: false,
    region: false,
  });

  const type = [
    { value: "PUBLIC", label: "PUBLIC" },
    { value: "REGIONAL", label: "REGIONAL" },
  ];

  const regionList = [
    { regionCode: 1682, name: "Nepal" },
    { regionCode: 1182, name: "GUWAHATI" },
    { regionCode: 1681, name: "Patna" },
    { regionCode: 3181, name: "DELHI" },
    { regionCode: 3281, name: "FARIDABAD" },
    { regionCode: 3381, name: "JALLANDHAR" },
    { regionCode: 3681, name: "JAIPUR" },
    { regionCode: 3682, name: "JODHPUR" },
    { regionCode: 3781, name: "KANPUR" },
    { regionCode: 3782, name: "MEERUT" },
    { regionCode: 3783, name: "VARANASI" },
    { regionCode: 5181, name: "H.BAD" },
    { regionCode: 5182, name: "VIJAYWADA" },
    { regionCode: 5381, name: "CHENNAI" },
    { regionCode: 5382, name: "Cochin" },
    { regionCode: 7181, name: "INDORE" },
    { regionCode: 1683, name: "RANCHI" },
    { regionCode: 7381, name: "MUMBAI" },
    { regionCode: 7382, name: "NAGPUR" },
    { regionCode: 7581, name: "AHMEDABAD" },
    { regionCode: 1181, name: "KOLKATTA" },
    { regionCode: 7182, name: "RAIPUR" },
    { regionCode: 7183, name: "JABALPUR" },
    { regionCode: 7184, name: "CUTTAK" },
    { regionCode: 5281, name: "BNGLR" },
    { regionCode: 3382, name: "CHANDIGARH" },
    { regionCode: 5282, name: "HUBLI" },
    { regionCode: 5383, name: "Coimbatore" },
    { regionCode: 7582, name: "RAJKOT" },
    { regionCode: 5384, name: "Madurai" }
  ];

  const { holidayDate, title, holidayType, region } = Values;

  const Validate = () => {
    let value = true;
    let err = {};

    if (title === "" || title === " ") {
      err.title = "Please Enter Holiday Name.";
      value = false;
    }

    if (holidayDate === "") {
      err.holidayDate = "Please Select Holiday date.";
      value = false;
    }

    if (holidayType === "") {
      err.holidayType = "Please Select Holiday Type.";
      value = false;
    }

    if (holidayType === "REGIONAL" && region.length === 0) {
      err.region = "Select Regions.";
      value = false;
    }

    setschemeErr({ ...err });
    return value;
  };

  useEffect(async () => {
    const holidayList = await getHolidayList();
    setData(holidayList?.data);
    setMessage(holidayList?.message);
    setLoading(true);
    setTotalPages(holidayList?.totalPage ?? 1);
  }, [message]);

  const handelSubmit = async () => {
    if (!Validate()) return;
    let { holidayDate, title, holidayType, ...rest } = Values;
    let data =
      holidayType === "PUBLIC"
        ? { holidayDate, title, holidayType }
        : { ...Values };
    const response = await authAxios()({
      url: `/api/v1/holiday`,
      method: "POST",
      data,
    });
    setMessage(response?.data?.message);
    setOpenModal(false);
    setValues({
      holidayDate: "",
      title: "",
      holidayType: "",
      region: [],
    });
    toastMessage(response?.data?.message, "success");
  };

  const handelUpdate = async () => {
    if (!Validate()) return;
    let { holidayDate, title, holidayType, ...rest } = Values;
    let data =
      holidayType === "PUBLIC"
        ? { holidayDate, title, holidayType }
        : { ...Values };

    const response = await authAxios()({
      url: `/api/v1/holiday/${Values?.id}`,
      method: "PUT",
      data,
    });
    setMessage(response?.data?.message);
    setEditModal(false);
    setValues({
      holidayDate: "",
      title: "",
      holidayType: "",
      region: [],
    });
    toastMessage(response?.data?.message, "success");
  };

  const confirmDelete = async (id) => {
    console.log("idd", id);
    const response = await authAxios()({
      url: `/api/v1/holiday/${id}`,
      method: "DELETE",
    });
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handleChange = (e) => {
    setValues({
      ...Values,
      [e.target.name]: e.target.value.replace(/\s+/g, " "),
    });
  };

  const handleRegionChange = (data) => {
    const isRegionIncluded = region.some((region) => region.name === data.name);
    if (isRegionIncluded) {
      setValues((prevValues) => ({
        ...prevValues,
        region: prevValues.region.filter((item) => item.name !== data.name),
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        region: [...prevValues.region, data],
      }));
    }
  };

  const handleDelete = async (id) => {
    setDeleteDialogOpen(true);
    setDeletedItemId(id);
  };

  const handleCloseDialog = () => {
    setDeleteDialogOpen(false);
    setDeletedItemId("");
  };

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const handleKeyPress = (e) => {
    const allowedCharacters = /^[a-zA-Z\s]+$/;
    if (!allowedCharacters.test(e.key)) {
      e.preventDefault();
    }
  };

  function excelDateToJSDate(serial) {
    // Number of milliseconds between 1900-01-01 and 1970-01-01
    const excelEpochOffset = 25569;
    const millisecondsPerDay = 24 * 60 * 60 * 1000;

    // Convert Excel serial number to milliseconds since 1970-01-01
    let milliseconds = (serial - excelEpochOffset) * millisecondsPerDay;

    // Construct Date object
    return new Date(milliseconds);
  }

  const readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(e.target.files[0]);
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        console.log("json", JSON.stringify(json));

        json.forEach((item) => {
          item.DATE = excelDateToJSDate(item.DATE);
        });

        console.log("json", JSON.stringify(json));
        // setBulkUploadData(json);
        if (
          "HOLIDAY NAME" in json[0] &&
          "TYPE" in json[0] &&
          "DATE" in json[0]
        ) {
          console.log("JSON", JSON.stringify(json));
          let arr = [];
          for (let j of json) {
            arr.push({
              type: j.TYPE,
              name: j["HOLIDAY NAME"],
              date: j.DATE,
              regions: j?.REGIONS
                ? j?.REGIONS.split(",").map((region) => region.trim())
                : null,
            });
          }
          console.log(JSON.stringify(arr));
          // setCsvData(arr);
          setBulkUploadData(arr);
          return;
        } else {
          alert(
            `Uploaded CSV file is missing "Holiday Title" or "Type" or "Date" field.`
          );
          ref.current.value = "";
        }
      };
    }
  };

  const bulkUpload = async () => {
    if (
      bulkUploadData.length <= 0 ||
      bulkUploadData === undefined ||
      bulkUploadData === null
    ) {
      return toastMessage("Upload Excel first.", "error");
    }
    let data = bulkUploadData;
    const response = await authAxios()({
      url: `/api/v1/holiday/bulkupload`,
      method: "POST",
      data,
    });
    console.log("repos", response);
    setMessage(response?.data?.message);
    toastMessage(response?.data?.message, "success");
    setUploadModal(false);
  };

  return (
    <>
      <PageHeader
        title="Holiday Calendar"
        subtitle="Manage public and regional holidays"
        action={
          <>
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={() => {
                setOpenModal(true);
              }}
            >
              Add holiday
            </Button>
            <Button
              variant="contained"
              startIcon={<UploadFileIcon />}
              onClick={() => setUploadModal(true)}
            >
              Bulk Upload
            </Button>
          </>
        }
      />

      {loading ? (
        <SectionCard title="Holidays" disablePadding>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Title</TableCell>
                  <TableCell align="center">Holiday Type</TableCell>
                  <TableCell align="center">Date</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data && data?.length > 0 ? (
                  data?.map((d) => (
                    <TableRow key={d._id}>
                      <TableCell align="left">{d?.title}</TableCell>
                      <TableCell align="center">{d?.holidayType}</TableCell>
                      <TableCell align="center">
                        {moment.utc(d?.holidayDate).format("YYYY-MM-DD")}
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          color="success"
                          onClick={() => {
                            setValues({
                              holidayType: d?.holidayType,
                              holidayDate: moment
                                .utc(d?.holidayDate)
                                .format("YYYY-MM-DD"),
                              region: d?.region,
                              title: d?.title,
                              id: d?._id,
                            });
                            setEditModal(true);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => handleDelete(d?._id)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} sx={{ border: "none" }}>
                      <EmptyState
                        icon={EventBusyOutlinedIcon}
                        title="No holidays available"
                        description="Add a holiday or bulk upload a calendar to get started."
                      />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePager
              totalPages={totalPages}
              page={currentPage}
              onPageChange={(p) => handlePageChange(null, p)}
            />
          </TableContainer>
        </SectionCard>
      ) : (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress />
        </Box>
      )}

      {isDeleteDialogOpen ? (
        <DeleteConfirmationModel
          onOpen={isDeleteDialogOpen}
          onClose={handleCloseDialog}
          confirmDelete={confirmDelete}
          deletedItemId={deletedItemId}
        />
      ) : null}

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setschemeErr({
            title: false,
            holidayDate: false,
            holidayType: false,
            region: false,
          });
          setValues({
            holidayDate: "",
            title: "",
            holidayType: "",
            region: [],
          });
        }}
      >
        <Box sx={messageStyle}>
          <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "center" }}>
            Add Holiday
          </Typography>
          <Stack spacing={2.5} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              onChange={handleChange}
              value={title}
              name="title"
              label="Holiday Name"
              variant="outlined"
              onKeyPress={handleKeyPress}
              error={schemeErr.title}
              helperText={schemeErr.title}
            />

            <TextField
              select
              fullWidth
              onChange={handleChange}
              value={holidayType}
              name="holidayType"
              label="Type of holiday"
              variant="outlined"
              error={schemeErr.holidayType}
              helperText={schemeErr.holidayType}
            >
              {type.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            {holidayType === "REGIONAL" ? (
              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  Select Regions
                </Typography>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  fullWidth
                  value={region}
                  renderValue={(region) => {
                    const data = region.map((n) => n.name);
                    return data.join(", ");
                  }}
                  name="region"
                  error={schemeErr.region}
                  helperText={schemeErr.region}
                >
                  {regionList.map((r) => (
                    <Box key={r.value} sx={{ ml: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={region.some(
                              (item) => item.name === r.name
                            )}
                          />
                        }
                        label={r.name}
                        onChange={(event) => handleRegionChange(r)}
                      />
                    </Box>
                  ))}
                </Select>
              </Box>
            ) : null}

            <TextField
              type={"date"}
              fullWidth
              onChange={handleChange}
              value={holidayDate}
              name="holidayDate"
              label="Holiday Date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              error={schemeErr.holidayDate}
              helperText={schemeErr.holidayDate}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setschemeErr({
                    title: false,
                    holidayDate: false,
                    holidayType: false,
                    region: false,
                  });
                  setValues({
                    holidayDate: "",
                    title: "",
                    holidayType: "",
                    region: [],
                  });
                  setOpenModal(false);
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={() => handelSubmit()}>
                Submit
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={editModal}
        onClose={() => {
          setEditModal(false);
          setschemeErr({
            title: false,
            holidayDate: false,
            holidayType: false,
            region: false,
          });
          setValues({
            holidayDate: "",
            title: "",
            holidayType: "",
            region: [],
          });
        }}
      >
        <Box sx={messageStyle}>
          <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "center" }}>
            Edit Holiday
          </Typography>
          <Stack spacing={2.5} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              onChange={handleChange}
              value={title}
              name="title"
              label="Holiday Name"
              variant="outlined"
              onKeyPress={handleKeyPress}
              error={schemeErr.title}
              helperText={schemeErr.title}
            />

            <TextField
              select
              fullWidth
              onChange={handleChange}
              value={holidayType}
              name="holidayType"
              label="Type of holiday"
              variant="outlined"
              error={schemeErr.holidayType}
              helperText={schemeErr.holidayType}
            >
              {type.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>

            {holidayType === "REGIONAL" ? (
              <Box>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1 }}
                >
                  Select Regions
                </Typography>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  multiple
                  fullWidth
                  value={region}
                  renderValue={(region) => {
                    const data = region.map((n) => n.name);
                    return data.join(", ");
                  }}
                  name="region"
                  error={schemeErr.region}
                  helperText={schemeErr.region}
                >
                  {regionList.map((r) => (
                    <Box key={r.value} sx={{ ml: 2 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={region.some(
                              (item) => item.name === r.name
                            )}
                          />
                        }
                        label={r.name}
                        onChange={(event) => handleRegionChange(r)}
                      />
                    </Box>
                  ))}
                </Select>
              </Box>
            ) : null}

            <TextField
              type={"date"}
              fullWidth
              onChange={handleChange}
              value={holidayDate}
              name="holidayDate"
              label="Holiday Date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              error={schemeErr.holidayDate}
              helperText={schemeErr.holidayDate}
            />

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
              <Button
                variant="outlined"
                color="error"
                onClick={() => {
                  setEditModal(false);
                  setschemeErr({
                    title: false,
                    holidayDate: false,
                    holidayType: false,
                    region: false,
                  });
                  setValues({
                    holidayDate: "",
                    title: "",
                    holidayType: "",
                    region: [],
                  });
                }}
              >
                Cancel
              </Button>
              <Button variant="contained" onClick={() => handelUpdate()}>
                Update
              </Button>
            </Box>
          </Stack>
        </Box>
      </Modal>

      <Modal
        open={uploadModal}
        onClose={() => {
          setUploadModal(false);
          setBulkUploadData([]);
        }}
      >
        <Box sx={messageStyle}>
          <Typography variant="h5" sx={{ fontWeight: 700, textAlign: "center" }}>
            Bulk Upload Holidays
          </Typography>

          <Stack spacing={1} sx={{ mt: 2 }}>
            <Typography variant="caption" color="text.secondary">
              {`* First Header Name Must Be <>HOLIDAY NAME<>`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`* Second Header Name Must Be <>TYPE (expected values : "REGIONAL" & "PUBLIC"<>`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`* Third Header Name Must Be <>DATE<>`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`* Fourth Header Name Must Be <>REGIONS (only in case of "REGIONAL" holidays). Comma Separated.<>`}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {`* Supported file format are ".csv .xlsx .xls"`}
            </Typography>
          </Stack>

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              color="primary"
              variant="outlined"
              startIcon={<GetAppIcon />}
              onClick={() => window.open(sampleFile)}
            >
              Download Sample file
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 2,
              mt: 3,
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Upload CSV :
            </Typography>
            <Button variant="outlined" component="label" startIcon={<UploadFileIcon />}>
              Choose File
              <input
                type="file"
                hidden
                accept=".csv, .xlsx, .xls"
                ref={ref}
                onChange={readUploadFile}
              />
            </Button>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
              mt: 3,
            }}
          >
            <Button
              variant="outlined"
              color="error"
              sx={{ width: "40%" }}
              onClick={() => setUploadModal(false)}
            >
              Close
            </Button>
            <Button
              variant="contained"
              onClick={bulkUpload}
              sx={{ width: "40%" }}
              disabled={bulkUploadData.length > 0 ? false : true}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

const Holiday = () => {
  return (
    <AccessController roles={["RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default Holiday;
